// extracted by mini-css-extract-plugin
export var avatar = "ReelReviews-module--avatar--b69cd";
export var card = "ReelReviews-module--card--e4368";
export var cardWrapper = "ReelReviews-module--cardWrapper--bbda8";
export var content = "ReelReviews-module--content--781ca";
export var media = "ReelReviews-module--media--1b012";
export var testimonial = "ReelReviews-module--testimonial--7a963";
export var wrapper = "ReelReviews-module--wrapper--b516d";